module.exports = __webpack_public_path__ + "img/tick.e992b661.svg";